import React, { Component, PropTypes } from 'react'

import { getProperty } from '../utils'
import { Loading } from '../misc'
import { TextInput } from '../ui'

export default class AdditionalInformation extends Component {
    static propTypes = {
        crewType: PropTypes.string.isRequired,
        crew_uuid: PropTypes.string.isRequired,
        data: PropTypes.object.isRequired,
        gear: PropTypes.object.isRequired,
        gearActions: PropTypes.object.isRequired,
        help: PropTypes.string,
        label: PropTypes.string,
        updateValue: PropTypes.func.isRequired,
        wrapped: PropTypes.bool,
    }

    static defaultProps = {
        label: 'Additional kit details',
        wrapped: true,
    }

    _updateValue = (data) => {
        let additionalInformation = getProperty(this.props.data, 'additional_information')

        if (! Array.isArray(additionalInformation)) {
            additionalInformation = []
        }

        let found = false

        const newAdditionalInformation = additionalInformation.map((item) => {
            if (item.crew_type === this.props.crewType) {
                found = true

                return {
                    ...item,
                    information: data.additional_information,
                }
            }

            return item
        })

        if (! found) {
            newAdditionalInformation.push({
                crew_type: this.props.crewType,
                information: data.additional_information,
            })
        }

        this.props.updateValue({ additional_information: newAdditionalInformation })
    }

    _sendPatchRequest = (data = this.props.data) => {
        const additionalInformation = getProperty(data, 'additional_information')
        let value = ''

        if (Array.isArray(additionalInformation)) {
            value = getProperty(
                additionalInformation.find((item) => item.crew_type === this.props.crewType),
                'information',
                ''
            )
        }

        // don't shortcut the PATCH request - it comes back in an unexpected format
        const shortcutPatch = false

        this.props.gearActions.patchGear(
            {
                additional_information: [
                    {
                        crew_type: this.props.crewType,
                        information: value,
                    },
                ],
            },
            this.props.crew_uuid,
            this.props.crewType,
            shortcutPatch
        )
    }

    render() {
        if (! this.props.data) {
            return <Loading />
        }

        let errors = null

        if (this.props.gear.errors.additional_information) {
            errors = this.props.gear.errors.additional_information.map((item) => item.information)
        }

        const additionalInformation = getProperty(this.props.data, 'additional_information')
        let data = ''

        if (Array.isArray(additionalInformation)) {
            for (const item of additionalInformation) {
                // find the item with the correct crew type
                if (item.crew_type === this.props.crewType) {
                    data = item.information
                }
            }
        }

        const widgetOnly = (
            <TextInput
                error={ errors }
                handleBlur={ this._sendPatchRequest }
                help={ this.props.help }
                label={ this.props.label }
                name="additional_information"
                rows={ 6 }
                type="textarea"
                updateValue={ this._updateValue }
                value={ data }
            />
        )

        if (! this.props.wrapped) {
            return widgetOnly
        }

        return (
            <div className="content__inner">
                <div className="box">
                    <div className="box__header">
                        <div className="box__title">
                            Professional Equipment
                        </div>
                    </div>
                    <div className="box__content box__content--padded">
                        { widgetOnly }
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/gear/additional_information.js